import "../css/style.css";

const Admin = () => {

    let vector1 = 0
    let vector2 = 0
    let vector3 = 0
    let vector4 = 0
    let vector5 = 0
    let vector6 = 0

    return (
        <>
<svg width="100%" height="100%" viewBox="0 0 1000 1000" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice">
  <polygon points="50,    0,    100,   100    0,       100 " fill="none" stroke="white" stroke-width="1"/> 

  <polygon points="100,   100,  150,   0      50,      0   " fill="none" stroke="white" stroke-width="1"/>
  
  <polygon points="150,   0,    200,   100    100,     100 " fill="none" stroke="white" stroke-width="1"/> 

  <polygon points="200,   100,  250,   0      150,     0   " fill="none" stroke="white" stroke-width="1"/>
  <rect width="100%" height="100%" fill="url(#triPattern)" />
</svg>=



        </>
    )
};



export default Admin;